import _ from "lodash";
import { AccountingNewEntity } from "../../entity/AccountingNewEntity";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";

export class AccountingNewGateway {
    HttpAdapter = new HttpAdapter();
    baseUrl = `${publicSettings.aws.baseUrls.accounting}/accounting`;

    constructor() {}

    async getNews({ accountingId, userId }) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/news/get-by-accountingid`,
                { accountingId, userId }
            );
            const notificationsOrdered = _.orderBy(
                response,
                ["createdAt"],
                ["desc"]
            );
            const notifications = notificationsOrdered.map(
                (notificationNew) => {
                    const newEntity = AccountingNewEntity.restore(
                        notificationNew
                    );
                    return newEntity;
                }
            );
            return notifications;
        } catch (err) {
            console.log(err);
        }
    }

    async updateRead({ ids }) {
        if (!ids?.length) return;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/news/update-read`,
                { _ids: ids }
            );

            return response;
        } catch (err) {
            console.log(err);
        }
    }
}
